export enum DbCommon {
    emptyInt = -2147483648,
    maxFileNameLength = 255,
    maxFileSize = 5e+6,
    maxFileUploadSize = 26184000,
}